import PropTypes from 'prop-types';

const intlPropType = PropTypes.shape({
  formatMessage: PropTypes.func.isRequired,
});

const questionItemsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    inlineText: PropTypes.bool,
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
);

const questionPropType = PropTypes.shape({
  description: PropTypes.string,
  id: PropTypes.string.isRequired,
  items: questionItemsPropType,
  options: PropTypes.shape(),
  question: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
});

const consentPropType = PropTypes.shape({
  questions: PropTypes.arrayOf(questionPropType).isRequired,
});

const customPagePropType = PropTypes.shape({
  subText: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
});

const customPagesPropType = PropTypes.shape({
  completed: customPagePropType,
  eligibl: customPagePropType,
  ineligible: customPagePropType,
  leave: customPagePropType,
  welcome: customPagePropType,
});

export {
  intlPropType,
  questionPropType,
  questionItemsPropType,
  consentPropType,
  customPagePropType,
  customPagesPropType,
};
export default PropTypes;
